import React from 'react'

function RightPanel() {
  return (
    <div></div>
  )
}

export default RightPanel